export const MEDIA_ALBUM_INITIAL_FORM = {
  title: "",
  slug: "",
  description: "",
  is_active: true,
  is_public: true,
  show_on_home: false,
  display_order: 0,
};

export const MEDIA_ALBUM_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Tous",
    description: "Afficher tous les albums.",
  },
  {
    value: "active",
    label: "Actifs",
    description: "Albums utilisables sur le site.",
  },
  {
    value: "inactive",
    label: "Masqués",
    description: "Albums désactivés.",
  },
];

export const MEDIA_ALBUM_HOME_OPTIONS = [
  {
    value: "all",
    label: "Tous",
    description: "Tous les albums.",
  },
  {
    value: "home",
    label: "Accueil",
    description: "Albums marqués pour l’accueil.",
  },
  {
    value: "not_home",
    label: "Hors accueil",
    description: "Albums non utilisés sur l’accueil.",
  },
];

export const MEDIA_ALBUM_LIMIT_OPTIONS = [10, 20, 50, 100];

export const MEDIA_ALBUM_FORM_HELPERS = [
  "Créez un album clair : Photos de la commune, Patrimoine, Vie locale...",
  "Cochez “Accueil” pour utiliser l’album dans le carrousel de la page d’accueil.",
  "La photo de couverture se choisit ensuite dans la gestion des photos de l’album.",
];

export const MEDIA_ALBUM_PICKER_DEFAULT_CATEGORY = "";